/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SubscriptionPackage } from './SubscriptionPackage';
import {
    instanceOfSubscriptionPackage,
    SubscriptionPackageFromJSON,
    SubscriptionPackageFromJSONTyped,
    SubscriptionPackageToJSON,
} from './SubscriptionPackage';

/**
 * @type SubscriptionDataCurrentPackage
 * 
 * @export
 */
export type SubscriptionDataCurrentPackage = SubscriptionPackage;

export function SubscriptionDataCurrentPackageFromJSON(json: any): SubscriptionDataCurrentPackage {
    return SubscriptionDataCurrentPackageFromJSONTyped(json, false);
}

export function SubscriptionDataCurrentPackageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionDataCurrentPackage {
    if (json == null) {
        return json;
    }
    if (instanceOfSubscriptionPackage(json)) {
        return SubscriptionPackageFromJSONTyped(json, true);
    }

    return {} as any;
}

export function SubscriptionDataCurrentPackageToJSON(json: any): any {
    return SubscriptionDataCurrentPackageToJSONTyped(json, false);
}

export function SubscriptionDataCurrentPackageToJSONTyped(value?: SubscriptionDataCurrentPackage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfSubscriptionPackage(value)) {
        return SubscriptionPackageToJSON(value as SubscriptionPackage);
    }

    return {};
}

